module.exports = __webpack_public_path__ + "assets/img/4_84.f318e155.jpg";